( function( global, toastr ) { // eslint-disable-line
    var pluginName = 'Notification';

    // Constructor
    function Notification() {
        this.init();
    }

    // TODO: Custom options
    Notification.prototype.init = function init() {
        // Default options
        toastr.options = {
            "closeButton": true,
            "debug": false,
            "newestOnTop": true,
            "progressBar": true,
            "positionClass": "toast-bottom-right",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "5000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        }
    };

    Notification.prototype.generate = function generate(arg) {
        var type = arg.type;
        var message = arg.message;
        var availableType = ['success', 'info', 'warning', 'error'];

        if (typeof type !== 'string' || typeof message !== 'string') {
            console.warn('The value of the type or message must be a string');
            return;
        }

        if (!availableType.contains(type)) {
            console.warn('Type must be an available type:', availableType);
            return;
        }

        if (typeof message === 'undefined') {
            console.warn('Message is undefined:');
            return;
        }

        toastr[type](message);
    };

    // Export to CommonJS
    if (typeof module !== 'undefined' && module.exports) module.exports = Notification;
    // Export to Browser
    else global[pluginName] = Notification; // eslint-disable-line

    // Instance
    window.Notification = new Notification();

    // Usage
    // window.Notification.generate({
    //     type: 'success',
    //     message: 'test1'
    // });
    // window.Notification.generate({
    //     type: 'warning',
    //     message: 'test2'
    // });
    // setTimeout(function() {
    //     window.Notification.generate({
    //         type: 'error',
    //         message: 'test3'
    //     });
    // }, 1000);


    $('body').on('app.init', function(ev) {
        var $container = $(ev.container),
            $notices = $container.find('[data-form-notification]');

        $notices.each(function() {
            var $notice = $(this);
            window.Notification.generate({
                type: $notice.data('form-notification'),
                message: $notice.text()
            });
            $notice.remove();
        });
    });

}( window,  require('toastr') ));
